import {createSlice, PayloadAction} from "@reduxjs/toolkit";


interface TreatmentState{
    elements: TreatmentElement[],
    currentPage: number,
    rowsPerPage: number,
    totalRows: number,
    sort: string [],
    loading: boolean,
}

export interface  TreatmentElement {
    _id: string
    notes: string
    executionDate: string
    microchipeCode: string
    boxDog: string
    shedDog: string
} 

interface PageableDto{
    page: number;
    size: number;
    sort: string[];
}

const initialState:  TreatmentState = {
    elements: [],
    currentPage: 0,
    rowsPerPage: 10,
    totalRows: 0,
    sort: ['dateCreated', 'asc'],
    loading: false
}
export interface GetAllElementPayloaTreatment {
    pageableDto: PageableDto;
}

interface PageableDto {
    page: number;
    size: number;
    sort: string[];
}

export const  Treatment = createSlice({
    name: " Treatment",
    initialState,
    reducers: {

        getAllElement : (state, action: PayloadAction<GetAllElementPayloaTreatment>) => {
            state.loading = true;
        },
        getAllElementSuccess: (state, action: PayloadAction<{ data :TreatmentElement[],currentPage: number, totalRows: number }>) => {
            state.elements = action.payload.data;
            state.currentPage = action.payload.currentPage;
            state.totalRows = action.payload.totalRows;
            state.loading = false;
        },
        getAllElementError: (state) => {state.loading = false;},

        handleComplete: (state, action: PayloadAction<{id:string, callback: () => void}>) => {
            state.loading = true
        },
        handleCompleteSuccess: (state, action: PayloadAction<string>) =>{
             state.elements = state.elements.filter(el => el._id !== action.payload)
        },
        handleCompleteError:() =>{},


      /*  saveElement: (state, action: PayloadAction<{ treatment: TreatmentElement , callback : () => void}>) => {
            state.loading = true;

        },
        saveElementSuccess: (state, actions: PayloadAction< TreatmentElement>) => {
            state.elements.push(actions.payload)
        },
        saveElementError: (state, action:PayloadAction< TreatmentElement>) => {},

        updateElement: (state, actions: PayloadAction<{ treatment: TreatmentElement , callback : () => void}>) => {
            state.loading = true;
        },
        updateElementSuccess: (state, actions: PayloadAction< TreatmentElement>) => {
            let index = state.elements.findIndex(element => element._id === actions.payload._id)
            state.elements[index] = actions.payload
        },
        updateElementError: () => {},

        deleteElement: (state, action: PayloadAction<{id:string, callback: () => void}>) => {},
        deleteElementSuccess: (state, action: PayloadAction<string>) => {},
        deleteElementError: () => {},*/
    }
})

export const {
    getAllElement,
    getAllElementSuccess,
    getAllElementError,
    handleCompleteError,
    handleCompleteSuccess,
    handleComplete
  /*  saveElement,
    saveElementSuccess,
    saveElementError,
    updateElement,
    updateElementSuccess,
    updateElementError,
    deleteElement,
    deleteElementSuccess,
    deleteElementError*/
} =  Treatment.actions

export default  Treatment.reducer